/**
 * Static option lists and labels rendered by the Minha Lais panels.
 * Kept as plain data so every panel renders exactly the same copy.
 */

// Shared field class of every raw <input>/<textarea> inside Minha Lais.
export const input =
  'w-full px-3 py-2.5 text-[14px] text-lais-text bg-white border border-[#e5e7eb] rounded-lais-sm focus:outline-none focus:border-lais-primary focus:ring-2 focus:ring-[#f5eef9] placeholder:text-lais-text-muted transition-all';

export const DIAS_LABELS = {
  seg: 'Segunda',
  ter: 'Terça',
  qua: 'Quarta',
  qui: 'Quinta',
  sex: 'Sexta',
  sab: 'Sábado',
  dom: 'Domingo',
};

export const PRE_AGENDAMENTO_OPERACOES = [
  { value: 'aluguel', label: 'Aluguel' },
  { value: 'venda', label: 'Compra' },
];

export const NOTIFICATION_CHANNELS = [
  { value: 'WHATSAPP', label: 'WhatsApp' },
  { value: 'SMS', label: 'SMS' },
  { value: 'EMAIL', label: 'E-mail' },
  { value: 'PUSH', label: 'Notificações do aplicativo' },
];

export const NOTIFICATION_PURPOSES = [
  {
    value: 'VISIT_REMINDER',
    label: 'Comunicações essenciais',
    helper: 'Visitas agendadas, propostas e faturas.',
  },
  {
    value: 'VISIT_CONFIRMATION',
    label: 'Mensagens informativas',
    helper: 'Dicas e lembretes para garantir uma boa experiência.',
  },
  {
    value: 'NEW_MATCH_ALERT',
    label: 'Alertas criados por você',
    helper:
      'Recomendações de imóveis de acordo com suas preferências de busca.',
  },
  {
    value: 'PRICE_DROP',
    label: 'Recomendações personalizadas por IA',
    helper: 'Receba recomendações de imóveis no WhatsApp.',
  },
  {
    value: 'INCIDENT',
    label: 'Mensagens promocionais',
    helper: 'Novos produtos, funcionalidades ou promoções.',
  },
];

export const PROFILE_OPTIONS = [
  { value: 'TENANT', label: 'Inquilino/Comprador' },
  { value: 'OWNER', label: 'Proprietário' },
  { value: 'AFFILIATE', label: 'Afiliado' },
];

export const WHATSAPP_PROVIDER_OPTIONS = [
  { value: 'embedded_signup', label: 'Embedded Signup Meta' },
  { value: '360dialog', label: '360dialog' },
  { value: 'evolution_qr', label: 'QR/Evolution' },
];

export const qualificationAnswerTypeOptions = [
  { value: 'text', label: 'Texto' },
  { value: 'cpf', label: 'CPF' },
  { value: 'money', label: 'Valor' },
  { value: 'single_select', label: 'Seleção única' },
  { value: 'multi_select', label: 'Seleção múltipla' },
  { value: 'boolean', label: 'Sim/Não' },
];

export const qualificationOperationOptions = [
  { value: 'both', label: 'Venda e locação' },
  { value: 'rent', label: 'Locação' },
  { value: 'sale', label: 'Venda' },
];
